import { PageContainer } from '../components/layout';
import RegisterTable from '../components/registers/RegisterTable';
import styles from './MyIncidentsPage.module.css';

/**
 * MyIncidentsPage (04-07) — the office "where did MY report go?" view.
 *
 * A `RegisterTable` for Incidents with the `Own only` token FORCED, regardless of
 * the signed-in role's broader default scope. This is the office-staff trail of
 * the incidents they personally lodged — Own-only keys off `reportedByEmail` for
 * Incidents (matrix §4, realized in the scope engine). It deliberately ignores
 * Portfolio / All so the list answers exactly "what I reported", which is the
 * reassurance an office user wants after lodging.
 *
 * (The SW-facing field own-report trail is Phase 5's magic-link surface; this is
 * the office Own-only — 04-07 plan scope.)
 *
 * Renders through the single scope engine (`applyScope` inside RegisterTable), so
 * visibility stays consistent with tiles + the register views. Honest empty state
 * against today's empty register; presentation-only (no writes).
 */
export default function MyIncidentsPage() {
  return (
    <PageContainer title="My incidents" maxWidth="full">
      <p className={styles.intro}>
        The incidents you’ve lodged — so you can see exactly where your reports
        landed and how they’re tracking. This shows only your own reports.
      </p>

      <RegisterTable
        registerKey="incidents"
        viewToken="Own only"
        emptyMessage="You haven’t lodged any incidents yet. When you do, they’ll appear here so you can follow them through."
      />
    </PageContainer>
  );
}
